var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyEmailCheckBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10090_4497",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.859528,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10090_4497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79703 13L14.7554 8.0625L13.6929 7L9.79703 10.875L8.02619 9.125L6.96369 10.1875L9.79703 13ZM10.8595 18C9.76231 18 8.72758 17.7917 7.75536 17.375C6.78314 16.9583 5.93244 16.3854 5.20328 15.6562C4.47411 14.9271 3.90119 14.0764 3.48453 13.1042C3.06786 12.1319 2.85953 11.0972 2.85953 10C2.85953 8.88889 3.06786 7.85069 3.48453 6.88542C3.90119 5.92014 4.47411 5.07292 5.20328 4.34375C5.93244 3.61458 6.78314 3.04167 7.75536 2.625C8.72758 2.20833 9.76231 2 10.8595 2C11.9706 2 13.0088 2.20833 13.9741 2.625C14.9394 3.04167 15.7866 3.61458 16.5158 4.34375C17.2449 5.07292 17.8179 5.92014 18.2345 6.88542C18.6512 7.85069 18.8595 8.88889 18.8595 10C18.8595 11.0972 18.6512 12.1319 18.2345 13.1042C17.8179 14.0764 17.2449 14.9271 16.5158 15.6562C15.7866 16.3854 14.9394 16.9583 13.9741 17.375C13.0088 17.7917 11.9706 18 10.8595 18ZM10.8595 16.5C12.6651 16.5 14.1998 15.8681 15.4637 14.6042C16.7276 13.3403 17.3595 11.8056 17.3595 10C17.3595 8.19444 16.7276 6.65972 15.4637 5.39583C14.1998 4.13194 12.6651 3.5 10.8595 3.5C9.05397 3.5 7.51925 4.13194 6.25536 5.39583C4.99147 6.65972 4.35953 8.19444 4.35953 10C4.35953 11.8056 4.99147 13.3403 6.25536 14.6042C7.51925 15.8681 9.05397 16.5 10.8595 16.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmailCheckBox);
export default __webpack_public_path__ + "static/media/verifyEmailCheckBox.e18922ea22249c98dfceb34fc50040e2.svg";
export { ForwardRef as ReactComponent };